export const LT_PROPERTIES_DATA_RECEIVED = 'LT_PROPERTIES_DATA_RECEIVED'
export const LT_PROPERTIES_DATA_FAILED = 'LT_PROPERTIES_DATA_FAILED'
export const LT_PROPERTY_SAVED = 'LT_PROPERTY_SAVED'
export const LT_PROPERTY_SAVE_FAILED = 'LT_PROPERTY_SAVE_FAILED'
export const LT_PROPERTY_DELETED = 'LT_PROPERTY_DELETED'
export const LT_PROPERTY_RECEIVED = 'LT_PROPERTY_RECEIVED'
export const LT_PROPERTY_RECEIVE_FAILED = 'LT_PROPERTY_RECEIVE_FAILED'
export const LT_PROPERTY_UNLOADED = 'LT_PROPERTY_UNLOADED'
